export var pageBreadcrumbs = {
    pojobnames: [{ label: 'Po Job Names' }],
    proallowance: [{ label: 'Pro Allowance Management' }],
    assignproallowance: [
        { label: 'Pro Allowance Management', path: '/myaccount/proallowance' },
        { label: 'Assign' },
    ],
};
